import useExportDashboardPopUpStyles from './ExportDashboardPopupThemes';
import { ExportDashboardPopUpProps } from './ExportDashboardPopupTypes';
import Popover from '@material-ui/core/Popover';
import React from 'react';
import FileTypeButton from './FileTypeButton/FileTypeButton';
import { FileTypes } from '../ExportDashboardTypes';

const ExportDashboardPopUp = ({ onClose, anchorEl, handleClick }: ExportDashboardPopUpProps) => {
  const isOpen = Boolean(anchorEl);
  const classes = useExportDashboardPopUpStyles();
  const AVAILABLE_EXPORT_TYPES: FileTypes[] = ['pptx', 'pdf'];
  return (
    <Popover
      disableScrollLock
      classes={classes}
      id={isOpen ? 'export-dashboard-popover' : undefined}
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
    >
      {AVAILABLE_EXPORT_TYPES.map(type => (
        <FileTypeButton handleClick={handleClick} type={type} />
      ))}
    </Popover>
  );
};

export default ExportDashboardPopUp;
